import * as React from 'react';
import { Theme, useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Stack } from '@mui/material';


interface ICustomDropDown{
    items:any[] , 
    label:string,
    value:string ,
    setValue:React.Dispatch<React.SetStateAction<string>>
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};



export default function CustomDropDown({items , label , value , setValue}:ICustomDropDown) {
  const theme = useTheme();

  const handleChange = (e:any) => {
  const value = e.target.value;
  setValue(value);
  };

  return (
    <Stack display="flex" justifyContent="flex-end">
      <FormControl sx={{ m: 1, width: 300 }}>
        <InputLabel id="demo-multiple-name-label">{label}</InputLabel>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          value={value}
          onChange={handleChange}
          input={<OutlinedInput label="Name" />}
          MenuProps={MenuProps}
        >
          {items.map((item) => (
            <MenuItem
              key={item?._id}
              value={item?._id}
            >
              {item?.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
}
